import React, { Component } from 'react'
import SelectButton from './selectButton'
import { FormGroup } from 'react-bootstrap'
import { translate } from 'react-translate'

@translate('FormSearch')
class FormSearch extends Component {
  render(){

    const {
      ambients,
      bathrooms,
      garages,
      bedrooms,
      naves,
      category,
      terrain,
      terrains,
      onSelectAmbients,
      onSelectBaths,
      onSelectGarages,
      onSelectRooms,
      onSelectNaves,
      onSelectCategory,
      onSelectTerrain,
      onChangeAreaMin,
      onChangeAreaMax,
      onChangeAreaMinLow,
      onChangeAreaMaxLow,
      onChangePriceMin,
      onChangePriceMax,
      currency,
      changeCurrency,
      originPath, originOffice,
      t
    } = this.props

    let titleAmbients = (ambients.length !== 0) ? ambients[0] : '1'
    let titleBaths = (bathrooms.length !== 0) ? bathrooms[0] : '1'
    let titleGarages = (garages.length !== 0) ? garages[0] : '1'
    let titleRooms = (bedrooms.length !== 0) ? bedrooms[0] : '1'
    let titleNaves = (naves.length !== 0) ? naves[0] : '1'
    let titleCategory = (category.length !== 0) ? category : '-'
    let titleTerrain = (terrain.length > 0) ? terrain[0].name : t('Seleccionar')

    let roomsOption = (
      <div className='panel-item'>
        <h2>{t('Dormitorios')}</h2>
        <SelectButton title={titleRooms} onSelectedItem={onSelectRooms}>
          {'-'}{1}{2}{3}{4}{5}{6}
         </SelectButton>
      </div>
    )

    let ambientsOption = (
      <div className='panel-item'>
        <h2>{t('Ambientes')}</h2>
        <SelectButton title={titleAmbients} onSelectedItem={onSelectAmbients}>
          {'-'}{1}{2}{3}{4}{5}{6}
         </SelectButton>
      </div>
    )

    let baths = (
      <div className='panel-item'>
        <h2>{t('Banos')}</h2>
        <SelectButton title={titleBaths} onSelectedItem={onSelectBaths}>
          {'-'}{1}{2}{3}{4}{5}{6}
         </SelectButton>
      </div>
    )

    let garagesOption = (
      <div className='panel-item'>
        <h2>{t('Cocheras')}</h2>
        <SelectButton title={titleGarages} onSelectedItem={onSelectGarages}>
          {'-'}{1}{2}{3}{4}{5}{6}
         </SelectButton>
      </div>
    )

    let navesOption = (
      <div className='panel-item'>
        <h2>{t('Cantidad_de_naves')}</h2>
        <SelectButton title={titleNaves} onSelectedItem={onSelectNaves}>
          {'-'}{1}{2}{3}{4}{5}{6}
         </SelectButton>
      </div>
    )

    let prices = (
      <div className='panel-item item-lg'>
        <FormGroup>
          <h2>{t('Precio')} </h2>
          <div className='radio-currency'>
            <label>
              <input type='radio' value={5} checked={currency === 5} onChange={() => changeCurrency(5)} />
              U$S
            </label>
            <label>
              <input type='radio' value={4} checked={currency === 4} onChange={() => changeCurrency(4)} />
              $ &nbsp; &nbsp;
            </label>
          </div>
        </FormGroup>
        <FormGroup className='minmax-group'>
          <input type='number' placeholder={t('Desde')} min='0' onChange={onChangePriceMin}></input>
          <input type='number' placeholder={t('Hasta')} min='0' onChange={onChangePriceMax}></input>
         </FormGroup>
      </div>
    )

    let surface = (
      <div className='panel-item item-lg'>
        <h2>{t('Superficie')} M2</h2>
        <FormGroup className='minmax-group'>
          <input type='number' placeholder={t('Desde')} min='0' onChange={onChangeAreaMin}></input>
          <input type='number' placeholder={t('Hasta')} min='0' onChange={onChangeAreaMax}></input>
         </FormGroup>
      </div>
    )

    let surfaceLow = (
      <div className='panel-item item-lg'>
        <h2>{t('Superficie_Planta_Baja')}</h2>
        <FormGroup className='minmax-group'>
          <input type='number' placeholder={t('Desde')} min='0' onChange={onChangeAreaMinLow}></input>
          <input type='number' placeholder={t('Hasta')} min='0' onChange={onChangeAreaMaxLow}></input>
         </FormGroup>
      </div>
    )

    let categoryOption = (
      <div className='panel-item'>
        <h2>{t('Categoría')}</h2>
        <SelectButton title={titleCategory} onSelectedItem={onSelectCategory}>
          {'-'}{'AAA'}{'A+'}{'A'}{'B'}{'C'}
         </SelectButton>
      </div>
    )

    let terrainUseOption = (
      <div className='panel-item'>
        <h2>{t('Uso_del_Terreno')}</h2>
        <SelectButton title={titleTerrain} onSelectedItem={onSelectTerrain} options={terrains}>
         </SelectButton>
      </div>
    )

    if (originOffice !== ''){
      switch (originOffice) {
        case 'puertos':
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {surface}
                {prices}
              </div>
            </div>
          )
        case 'nordelta':
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {roomsOption}
                {surface}
                {prices}
              </div>
            </div>
          )
        case 'recoleta':
        case 'palermo':
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {ambientsOption}
                {garagesOption}
                {surface}
                {prices}
              </div>
            </div>
          )
        default:
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {ambientsOption}
                {baths}
                {surface}
                {prices}
              </div>
            </div>
          )
      }
    }
    else{
      switch (originPath) {
        case 'Residencial':
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {ambientsOption}
                {baths}
                {surface}
                {prices}
              </div>
            </div>
          )
        case 'Oficina':
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {categoryOption}
                {garagesOption}
                {surface}
                {prices}
              </div>
            </div>
          )
        case 'Locales':
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {surface}
                {surfaceLow}
                {prices}
              </div>
            </div>
          )
        case 'Terrenos':
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {terrainUseOption}
                {surface}
                {prices}
              </div>
            </div>
          )
        case 'Industrias':
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {navesOption}
                {surface}
                {prices}
              </div>
            </div>
          )
        default:
          return (
            <div className='form-searchbar'>
              <div className='inputs-box'>
                {surface}
                {prices}
              </div>
            </div>
          )
      }
    }
  }
}

export default FormSearch



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/FormSearch/FormSearch.component.js